var _excluded = ["anchorElement", "children", "isOpen", "disableMinWidthAsAnchor", "showBorder", "menuRootClassName", "dropDownPosition", "usePopper", "usePopperPositionFixed", "dropDownMargin"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from 'react';
import { Popper } from 'react-popper';
import Measure from 'react-measure';
import { color } from "../../../styles/theme";
import { Z_DEPTH_SHADOWS } from "../../../constants/sharedConstants";
import DropDownList from "./DropDownList";
var CONFIG = {
  borderWidth: 1,
  boxShadow: Z_DEPTH_SHADOWS[1],
  defaultMargin: 6,
  modalContentLabel: 'dropDownMenu'
};
var DropDownMenu = /*#__PURE__*/function (_React$Component) {
  function DropDownMenu() {
    var _this;
    _classCallCheck(this, DropDownMenu);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DropDownMenu, [].concat(args));
    _defineProperty(_this, "menu", undefined);
    _defineProperty(_this, "focusHandle", undefined);
    _defineProperty(_this, "state", {
      width: undefined,
      height: undefined
    });
    _defineProperty(_this, "handleClickOutside", function (event) {
      if (_this.menu && _this.menu.dropdownList && _this.props.anchorElement && !_this.menu.dropdownList.contains(event.target) && !_this.props.anchorElement.contains(event.target)) {
        _this.props.onRequestClose();
      }
    });
    _defineProperty(_this, "handleMenuFocus", function () {
      _this.focusHandle = undefined;
      if (_this.menu && _this.menu.dropdownList) {
        _this.menu.dropdownList.focus();
      }
    });
    _defineProperty(_this, "onMeasure", function (_ref) {
      var bounds = _ref.bounds;
      _this.setState({
        width: bounds.width,
        height: bounds.height
      });
    });
    _defineProperty(_this, "_setMenuRef", function (node) {
      var shouldUpdateFocus = _this.props.isOpen && _this.menu == null && node != null;
      _this.menu = node;
      if (shouldUpdateFocus && _this.focusHandle == null) {
        _this.focusHandle = setTimeout(_this.handleMenuFocus, 0);
      }
    });
    return _this;
  }
  _inherits(DropDownMenu, _React$Component);
  return _createClass(DropDownMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleClickOutside);
      document.addEventListener('keyup', this.handleClickOutside);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.focusHandle != null) {
        clearTimeout(this.focusHandle);
      }
      document.removeEventListener('keyup', this.handleClickOutside);
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "getModalStyle",
    value: function getModalStyle() {
      var _this$props = this.props,
        anchorElement = _this$props.anchorElement,
        borderColor = _this$props.borderColor,
        dropDownMargin = _this$props.dropDownMargin,
        dropDownPosition = _this$props.dropDownPosition,
        isOpen = _this$props.isOpen,
        showBorder = _this$props.showBorder;
      var _this$state = this.state,
        width = _this$state.width,
        height = _this$state.height;
      var modalStyle = {
        content: {
          position: 'absolute',
          backgroundColor: color.white,
          width: 'fit-content',
          top: 'auto',
          bottom: 'auto',
          left: 'auto',
          right: 'auto',
          border: 'none',
          borderRadius: '0',
          boxShadow: 'none',
          padding: '0',
          zIndex: '1'
        }
      };
      if (isOpen) {
        // Apply border/box-shadow to modal instead of DropDownList
        if (showBorder) {
          modalStyle.content.border = "".concat(CONFIG.borderWidth, "px solid ").concat(borderColor);
        } else {
          modalStyle.content.boxShadow = CONFIG.boxShadow;
        }

        // Apply positioning styles
        if (anchorElement) {
          var offsetLeft = anchorElement.offsetLeft,
            offsetTop = anchorElement.offsetTop,
            offsetHeight = anchorElement.offsetHeight,
            offsetWidth = anchorElement.offsetWidth;
          var borderMargin = showBorder ? CONFIG.borderWidth * 2 : 0;

          // Default positioning: bottom left
          var menuTop = offsetTop + offsetHeight + dropDownMargin;
          var menuLeft = offsetLeft;
          if (width && height) {
            menuTop = dropDownPosition.vertical === 'top' ? offsetTop - (height + dropDownMargin + borderMargin) : offsetTop + offsetHeight + dropDownMargin;
            menuLeft = dropDownPosition.horizontal === 'right' ? offsetLeft + offsetWidth - width : offsetLeft;
          }

          // Need to factor in offset from window scrolling
          modalStyle.content.top = "".concat(menuTop, "px");
          modalStyle.content.left = "".concat(menuLeft, "px");
        }
      }
      return modalStyle;
    }
  }, {
    key: "_getModalStyleWithPopper",
    value: function _getModalStyleWithPopper(popperStyle) {
      var _this$props2 = this.props,
        borderColor = _this$props2.borderColor,
        showBorder = _this$props2.showBorder;
      var modalStyle = {
        overlay: {
          position: 'absolute',
          backgroundColor: 'none'
        },
        content: _objectSpread({
          position: 'absolute',
          backgroundColor: color.white,
          width: 'fit-content',
          top: 'auto',
          bottom: 'auto',
          left: 'auto',
          right: 'auto',
          border: showBorder ? "".concat(CONFIG.borderWidth, "px solid ").concat(borderColor) : 'none',
          borderRadius: '0',
          boxShadow: showBorder ? 'none' : CONFIG.boxShadow,
          padding: '0',
          zIndex: '1'
        }, popperStyle)
      };
      return modalStyle;
    }
  }, {
    key: "_toPopperPlacement",
    value: function _toPopperPlacement(dropDownPosition) {
      if (!dropDownPosition) {
        return 'auto-start';
      }
      var vertical = dropDownPosition.vertical || 'bottom';
      var horizontal = dropDownPosition.horizontal || 'left';
      if (vertical === 'bottom') {
        if (horizontal === 'left') {
          return 'bottom-start';
        }
        if (horizontal === 'right') {
          return 'bottom-end';
        }
      }
      if (vertical === 'top') {
        if (horizontal === 'left') {
          return 'top-start';
        }
        if (horizontal === 'right') {
          return 'top-end';
        }
      }
      return 'auto-start';
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        anchorElement = _this$props3.anchorElement,
        children = _this$props3.children,
        isOpen = _this$props3.isOpen,
        disableMinWidthAsAnchor = _this$props3.disableMinWidthAsAnchor,
        showBorder = _this$props3.showBorder,
        menuRootClassName = _this$props3.menuRootClassName,
        dropDownPosition = _this$props3.dropDownPosition,
        _this$props3$usePoppe = _this$props3.usePopper,
        usePopper = _this$props3$usePoppe === void 0 ? false : _this$props3$usePoppe,
        _this$props3$usePoppe2 = _this$props3.usePopperPositionFixed,
        usePopperPositionFixed = _this$props3$usePoppe2 === void 0 ? false : _this$props3$usePoppe2,
        dropDownMargin = _this$props3.dropDownMargin,
        dropDownListProps = _objectWithoutProperties(_this$props3, _excluded);

      // Set aria-expanded on anchor button
      // TODO(ppaskaris): Remove this side effect.
      if (anchorElement) {
        anchorElement.setAttribute('aria-expanded', isOpen);
      }
      if (!isOpen) {
        return null;
      }
      if (usePopper) {
        return /*#__PURE__*/React.createElement(Popper, {
          placement: this._toPopperPlacement(dropDownPosition),
          positionFixed: usePopperPositionFixed,
          modifiers: {
            offset: {
              offset: "0,".concat(dropDownMargin)
            }
          }
        }, function (_ref2) {
          var style = _ref2.style,
            ref = _ref2.ref;
          return /*#__PURE__*/React.createElement("div", {
            ref: ref,
            style: _this2._getModalStyleWithPopper(style).content,
            className: menuRootClassName
          }, style.transform ? /*#__PURE__*/React.createElement(DropDownList, _extends({
            ref: _this2._setMenuRef
          }, dropDownListProps), children) : null);
        });
      } else {
        var anchorWidth;
        if (!disableMinWidthAsAnchor && anchorElement) {
          var rect = anchorElement.getBoundingClientRect();
          var borderMargin = showBorder ? CONFIG.borderWidth * 2 : 0;
          anchorWidth = rect.width - borderMargin;
        }
        return /*#__PURE__*/React.createElement("div", {
          style: this.getModalStyle().content,
          className: menuRootClassName
        }, /*#__PURE__*/React.createElement(Measure, {
          bounds: true,
          onResize: this.onMeasure
        }, function (_ref3) {
          var measureRef = _ref3.measureRef;
          return /*#__PURE__*/React.createElement("div", {
            ref: measureRef
          }, /*#__PURE__*/React.createElement(DropDownList, _extends({
            minWidth: anchorWidth,
            ref: _this2._setMenuRef
          }, dropDownListProps), children));
        }));
      }
    }
  }]);
}(React.Component);
_defineProperty(DropDownMenu, "defaultProps", {
  borderColor: color.primary,
  dropDownMargin: CONFIG.defaultMargin,
  dropDownPosition: {
    vertical: 'bottom',
    horizontal: 'left'
  },
  onRequestClose: function onRequestClose() {}
});
export { DropDownMenu as default };